import styled from "styled-components";

const MagSc = styled.div`
  margin: 10px;
  padding: 5px;
  height: 90vh;
  border-radius: 10px;
  /* fallback for old browsers */
  width: 100vw;
  /* Chrome 10-25, Safari 5.1-6 */
  position: absolute;
  top: 45px;
  .modalBackground1 {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.25);
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .rpm-button {
    padding: 20px;
    margin: 23px;
  }
  .self-evaluation {
    width: 35%;
    background-color: whitesmoke;

    margin: 30px;
    border-radius: 3px;
    background-color: whitesmoke;
  }

  option {
    font-size: 13px;
  }
  .modalContainer1 {
    width: 100vw;
    border-radius: 12px;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    display: flex;
    flex-direction: column;
    padding: 10px;
  }

  .modalContainer1 .title1 {
    display: inline-block;
    text-align: center;
    margin-top: 10px;
  }
  .closeButton1 {
    display: flex;
    justify-content: flex-end;
  }

  .closeButton1 button {
    background-color: transparent;
    border: none;
    font-size: 25px;
    cursor: pointer;
  }

  .modalContainer1 .body1 {
    flex: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .modalContainer1 .footer1 {
    flex: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modalContainer1 .footer1 button {
    width: 150px;
    height: 40px;
    margin: 10px;
    border: none;
    background-color: cornflowerblue;
    color: white;
    border-radius: 8px;
    font-size: 20px;
    cursor: pointer;
  }

  #footercancel {
    background-color: crimson;
  }

  body {
    background-color: whitesmoke;
  }

  .label {
    display: inline-block;
    width: 40%;
    text-align: left;
    padding: 20px;
  }

  .review-input1 {
    width: 26%;
    border-radius: 5px;

    padding: 10px 18px;

    margin: 10px 0;
  }
  .App1 {
    width: 100 vw;
    height: 100 vh;
    display: flex;

    flex-direction: column;
  }

  .App1 h1 {
    width: 100 vw;
    height: 100 vh;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .App1 .openModalBtn1 {
    margin-left: 32px;
    width: 200px;
    height: 40px;
    border: none;
    border-radius: 6px;
    background-color: cornflowerblue;
    color: white;
    cursor: pointer;
  }
  .request-conatiner1 {
    background-color: #edecec;
    padding: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 30px;
    border-radius: 8px;
  }
  .objective-modal {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .modal-objective {
    height: calc(100vh - 150px);
    overflow-y: auto;
  }
  textarea {
    width: 100%;
    height: 150px;
    padding: 12px 20px;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    background-color: #f8f8f8;
    font-size: 16px;
    resize: none;
  }
  .objective-modal-main {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .objective-submit {
    width: 20%;
    padding: 5px 15px;
    align-self: center;
    align-items: center;
    appearance: button;
    background-color: #0276ff;
    border-style: none;
    border-radius: 5px;
    color: #fff;
  }
  .objective-submit:active {
    background-color: #006ae8;
  }
  .objective-submit:hover {
    background-color: #1c84ff;
  }
  .goals-heading {
    display: flex;
    justify-content: space-between;
  }
  .evaluation {
    padding: 5px 8px;
    box-sizing: border-box;
    border: 2px solid;
    border-radius: 5px;
  }
  .objective {
    padding: 5px 8px;
    box-sizing: border-box;
    border: 2px solid;
    border-radius: 5px;
  }
  textarea {
    border: 2px solid;
  }
  .project {
    border: 2px solid;
    border-radius: 5px;
    padding: 5px 8px;
  }
  .due-dates {
    border: 2px solid;
    border-radius: 5px;
  }
  .due-date {
    align-self: flex-end;
    display: flex;
    align-items: center;
  }
  .history-header {
    background-color: #edecec;
    padding: 8px 10px;
    display: flex;
    justify-content: space-between;
    border-radius: 5px;
  }
  .development-objectives {
    background-color: #edecec;
    padding: 8px 10px;
    display: flex;
    border-radius: 5px;
    align-items: center;
  }
  .project-goals {
    background-color: #edecec;
    padding: 8px 10px;
    border-radius: 5px;
    align-items: center;
  }
  .user-goals {
    display: flex;
    justify-content: space-between;
  }
  .modal-body-performance {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1em;
  }
  .project-user-goals {
    display: flex;
    flex-direction: column;
    gap: 1em;
  }
  .org-goal-header {
    padding: 1rem 2rem;
    background-color: rgb(243, 240, 240);
    border-radius: 3px;
  }
  .evaluation-objective-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
  }
  .evaluation-container {
    display: flex;
    flex-direction: column;

    gap: 0.5rem;
  }
  .objective-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1rem;
  }
  .evaluation-main {
    background-color: #f8f8f8;
    padding: 1rem 2rem;
  }
  .objective-main {
    display: flex;
    flex-direction: column;
    gap: 0.7rem;
  }
  .type {
    display: flex;
    justify-content: space-between;
  }
  .project-goals-main {
    background-color: #f8f8f8;
    padding: 1rem 2rem;
    display: flex;
    justify-content: space-between;
  }
  .user-goal-main {
    background-color: #edecec;
    padding: 1rem 2rem;
    display: flex;
    flex-direction: column;
    margin: 30px;
    border-radius: 8px;
    gap: 0.8rem;
  }
  .user-gaol-title-main {
    display: flex;
    justify-content: space-between;
    padding: 2rem;
  }
  label {
    font-size: medium;
    font-weight: 800;
  }
  .goal-edit-button {
    align-self: flex-end;
  }
  .modal-close-button {
    border: none;
    background-color: none;
  }
  .goal-edit-button {
    border: none;
    padding: 0.4rem 0.8rem;
    border-radius: 5px;
    background-color: #0629c4e0;
  }

  element.style {
    display: block;
  }
  @media (max-width) {
  }
`;

export default MagSc;
